import React, { useEffect, useState } from 'react';
import { ChevronDown } from 'lucide-react';

const HeroSection: React.FC = () => {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section id="home" className="relative h-screen overflow-hidden">
      {/* Parallax Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('/training-professionals.jpg')`,
          transform: `translateY(${scrollY * 0.5}px)`,
          backgroundPosition: '50% 30%',
        }}
      >
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative h-full flex items-center justify-center">
        <div className="text-center text-white px-6">
          {/* AI Performance Logo - Centered and Perfectly Sized */}
          <div className="flex justify-center mb-8 animate-fadeIn">
            <img
              src="/ai-logo.png"
              alt="AI Performance Solutions"
              className="h-32 md:h-40 lg:h-48 w-auto object-contain"
              style={{ maxWidth: '90vw' }}
            />
          </div>
          
          <p className="font-montserrat text-lg md:text-xl mt-6 mb-4 max-w-3xl mx-auto animate-slideUp font-light">
            World-renowned fitness resolutions focus on holistic, long-term well-being rather than short-term results
          </p>

          <div className="text-2xl md:text-3xl font-bebas tracking-wide mb-10 animate-slideUp text-primary">
            MOVE BETTER. PERFORM BETTER.
          </div>

          <button
            onClick={() => {
              const element = document.querySelector('#booking');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-primary hover:bg-red-600 text-white font-montserrat font-bold px-10 py-5 text-lg tracking-wider transition-all duration-300 transform hover:scale-105 animate-slideUp shadow-2xl"
          >
            BOOK NOW
          </button>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <ChevronDown size={32} className="text-white/70" />
      </div>
    </section>
  );
};

export default HeroSection;